import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-slate-200 shadow-2xl" data-testid="cookie-consent">
      <div className="container-main flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-600 max-w-2xl">
          We use cookies to enhance your experience, analyze site traffic, and serve relevant ads. 
          By clicking "Accept", you consent to our use of cookies. {' '}
          <a href="/privacy" className="text-emerald-600 hover:underline">Privacy Policy</a> | {' '}
          <a href="/disclaimer" className="text-emerald-600 hover:underline">Affiliate Disclosure</a>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <Button variant="outline" size="sm" onClick={decline} data-testid="cookie-decline">Decline</Button>
          <Button size="sm" className="bg-emerald-700 hover:bg-emerald-800" onClick={accept} data-testid="cookie-accept">Accept</Button>
        </div>
      </div>
    </div>
  );
}
